import { useTolgee } from '@tolgee/react'
import type { AppLocale } from '@kcm/contracts'
import { LOCALE_NATIVE_NAME } from '@kcm/i18n'
import { useSite } from './SiteProvider'

/**
 * The language switcher (PLAN.md §17). Hidden when a site enables one locale —
 * there is nothing to choose. Each option is shown in its own script so a user
 * recognises their language without reading English.
 */
export function LocalePicker() {
  const site = useSite()
  const tolgee = useTolgee(['language'])

  if (site.enabledLocales.length < 2) return null
  const current = tolgee.getLanguage() ?? site.defaultLocale

  return (
    <label className="inline-flex items-center gap-1 text-xs text-muted">
      <span className="sr-only">Language</span>
      <select
        value={current}
        onChange={(e) => void tolgee.changeLanguage(e.target.value)}
        className="rounded border border-line bg-surface px-2 py-1 text-ink"
      >
        {site.enabledLocales.map((l) => (
          <option key={l} value={l}>
            {LOCALE_NATIVE_NAME[l as AppLocale] ?? l}
          </option>
        ))}
      </select>
    </label>
  )
}
